export function extractUUIDTail(uuid: string) {
  const parts = uuid.split("-");
  if (parts.length !== 5) {
    return "";
  }

  // 最後のフィールド（16進数文字列）
  const lastFieldHex = parts.pop();

  // 16進数を 10進数に変換（BigInt を使用して桁数オーバー対応）
  const decimalValue = BigInt("0x" + lastFieldHex).toString(10);

  // 0埋めして固定長にする
  return decimalValue.padStart(15, "0");
}

export function idForDisplay(uuid: string): string {
  const segments = uuid.split("-");
  const reversedSegments = segments.reverse();
  const firstSegmentDecimal = BigInt("0x" + reversedSegments[0]).toString(10).padStart(15, "0");
  return `${firstSegmentDecimal}-${reversedSegments.slice(1).join("-")}`;
}